import React from "react";
import { useSelector, useDispatch } from "react-redux";
import classnames from "classnames";

import styles from "./content-word.module.css";
import * as contentWordActions from "../../redux/actions/contentWord";
import { srcPath } from "../../util/Path";
import { State } from "../../redux/store";
import { useImgLoaded } from "../../hooks/CustomHooks";
import { backToWeb } from "../../util/Util";

const FinishBoard = () => {
  const dispatch = useDispatch();
  const { grade, unit, webUrl } = useSelector((state: State) => state.shared);
  const { score } = useSelector((state: State) => state.contentWord);
  const [imgLoaded, addImgLoaded] = useImgLoaded(4);

  const onPlayAgain = () => {
    dispatch(contentWordActions.playAgain());
  };

  return (
    <div style={{ display: imgLoaded ? "block" : "none" }}>
      <img
        className={classnames("abs", styles.finishBoard)}
        src={srcPath("content-word/finish_board.png")}
        alt=""
        onLoad={addImgLoaded}
      />
      <div className={classnames("abs", styles.finishText)}>Good job!</div>
      <img
        className={classnames("abs", styles.finishBadge)}
        src={srcPath("content-word/finish_badge.png")}
        alt=""
        onLoad={addImgLoaded}
      />
      <div className={classnames("abs", styles.finishScore)}>{score}</div>
      <img
        className={classnames("abs", "btn", "main-btn", styles.finishBack)}
        src={srcPath("content-word/finish_back.png")}
        alt=""
        onLoad={addImgLoaded}
        onClick={() => backToWeb("small_book", webUrl, grade, unit)}
      />
      <img
        className={classnames("abs", "btn", "main-btn", styles.finishPlayAgain)}
        src={srcPath("content-word/finish_play_again.png")}
        alt=""
        onLoad={addImgLoaded}
        onClick={onPlayAgain}
      />
    </div>
  );
};

export default FinishBoard;
